import React from 'react'; 
import styled from 'styled-components';
const SplitterBar = ({height, color, margin, padding}) => { 
    return (
        <BarItem height={height} color={color} padding={padding} margin={margin}> 
        </BarItem>
    )
}

export const BarItem = styled.div`
    background : black;
    display: block;
    width : 100%;
    background: ${({color})=>{return (color)?color:'black'}};
    height: ${({height})=>{ return (height)? `${height}`: `1px`;}};
    margin : ${({margin})=>{ return (margin)? `${margin}`: `0px`;}};
    padding : ${({padding})=>{ return (padding)? `${padding}`: `0px`;}};
`
export default SplitterBar;